<template>
  <div class="PageMyReleaseOrderInfoAuthMobile">
    <PageHeaderMobile :pageHeaderTitle="pageHeaderTitle" @goBack="goBack"></PageHeaderMobile>

    <div class="section-top">
      <CardOrder>
        <div slot="cardHeader" class="card-header">
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.releaseNumber") }}</div>
            <div class="value value-highlight">{{ releaseData.releaseOrderNo }}</div>
          </div>
        </div>
        <div slot="cardFooter" class="card-footer">
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.netWeight") }}</div>
            <div class="value">{{ totalNetWeight }}</div>
          </div>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.grossWeight") }}</div>
            <div class="value">{{ totalGrossWeight }}</div>
          </div>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.reserveLocation") }}</div>
            <div class="value">{{ $store.getters.getSysCodeText("location", reserveData.reserveLocation) }}</div>
          </div>
          <div class="card-item">
            <div class="label">Plant Code</div>
            <div class="value">{{ releaseData.plantCode }}</div>
          </div>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.scaleLocation") }}</div>
            <div class="value">{{ releaseData.scaleLocation }}</div>
          </div>
        </div>
      </CardOrder>
    </div>

    <Tabs :tabsData.sync="tabsData" :active="activeTab">
      <div slot="first">
        <div class="grid-card">
          <CardTable v-for="data in releaseSOData" :key="data.soLine">
            <div class="card-item">
              <div class="label">SO LINE</div>
              <div class="value">{{ data.SOLine }}</div>
            </div>
            <div class="card-item">
              <div class="label">{{ $t("pages.wording.area") }}</div>
              <div class="value">{{ reserveData.reserveArea }}</div>
            </div>
            <div class="card-item">
              <div class="label">{{ $t("pages.wording.partNo") }}</div>
              <div class="value">{{ data.partNo }}</div>
            </div>
            <div class="card-item">
              <div class="label">{{ $t("pages.wording.partName") }}</div>
              <div class="value">{{ displayPartName(getLanguage(), data.partNameCN, data.partName) }}</div>
            </div>
            <div class="card-item">
              <div class="label">{{ $t("pages.wording.grossWeight") }}</div>
              <div class="value">{{ parseFloat(data.grossWeight.toFixed($global.defaultPointNumForRelease)) }}</div>
            </div>
            <div class="card-item">
              <div class="label">{{ $t("pages.wording.packType") }}</div>
              <div class="value">{{ $store.getters.getSysCodeText("packType", data.packType) }}</div>
            </div>
            <div class="card-item">
              <div class="label">{{ $t("pages.wording.packWeight") }}</div>
              <div class="value">{{ data.packWeight }}</div>
            </div>
            <div class="card-item">
              <div class="label">{{ $t("pages.wording.netWeight") }}</div>
              <div class="value">{{ parseFloat(data.netWeight.toFixed($global.defaultPointNumForRelease)) }}</div>
            </div>
            <div class="card-item">
              <div class="label">{{ $t("pages.wording.unit") }}</div>
              <div class="value">{{ data.unit }}</div>
            </div>
            <div class="card-item">
              <div class="label">Plant Code</div>
              <div class="value">{{ data.plantCode }}</div>
            </div>
          </CardTable>
        </div>
      </div>
      <div slot="second">
        <CardTable>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.reserveNo") }}</div>
            <div class="value">{{ reserveData.reserveNo }}</div>
          </div>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.carPlat") }}</div>
            <div class="value">{{ reserveData.tempCar ? reserveData.tmpCarPlat : reserveData.carPlat }}</div>
          </div>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.releaseTotalWeight") }}</div>
            <div class="value">{{ totalNetWeight }} {{ weightUnit }}</div>
          </div>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.emptyCar") }}</div>
            <div class="value">{{ releaseData.emptyCarWeight }}</div>
          </div>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.grossWeight") }}</div>
            <div class="value">{{ totalGrossWeight }} {{ weightUnit }}</div>
          </div>
        </CardTable>
      </div>
      <div slot="third">
        <CardTable>
          <div class="card-item">
            <div class="label">{{ $t("pages.wording.departuretime") }}</div>
            <div class="value">{{ parseDateTime(reserveData.leaveDatetime) }}</div>
          </div>
          <div class="card-item">
            <ApprovalProgressIndicator :progressData="approvalProgressData"></ApprovalProgressIndicator>
          </div>
        </CardTable>
      </div>
    </Tabs>

    <BottomButtonGroup v-if="roleNotYetSign">
      <div class="button-group">
        <el-button class="button-primary" type="primary" @click="applyReviewResult">{{
          $t("pages.button.exam")
        }}</el-button>
      </div>
    </BottomButtonGroup>
  </div>
</template>

<script>
import { api } from "@/utils/api.js"
import { utils } from "@/utils/utils.js"
import { mapGetters } from "vuex"
import CardOrder from "@/components/common/CardOrder.vue"
import ApprovalProgressIndicator from "@/components/common/ApprovalProgressIndicator.vue"
import Tabs from "@/components/common/Tabs.vue"
import PageHeaderMobile from "@/components/common/PageHeaderMobile.vue"
import BottomButtonGroup from "@/components/common/BottomButtonGroup.vue"
import CardTable from "@/components/common/CardTable.vue"

export default {
  name: "PageMyApprovalReleaseFormMobile",
  components: {
    CardOrder,
    ApprovalProgressIndicator,
    Tabs,
    PageHeaderMobile,
    BottomButtonGroup,
    CardTable,
  },
  props: {
    releaseID: {
      type: Number,
      default: () => -1,
    },
  },
  data() {
    return {
      pageHeaderTitle: this.$t("pages.wording.releaseOrder"),
      activeTab: "first",
      tabsData: [
        {
          name: "first",
          label: this.$t("pages.wording.releaseDetail"),
        },
        {
          name: "second",
          label: this.$t("pages.wording.reserveDetail"),
        },
        {
          name: "third",
          label: this.$t("pages.wording.approvalRecords"),
        },
      ],
      releaseFormID: -1,
      reserveData: [],
      releaseData: [],
      releaseSOData: [],
      approvalProgressData: [],
      roleNotYetSign: false,
    }
  },
  created() {
    this.init()
  },
  methods: {
    ...mapGetters(["getUserProfile", "getUserRoles", "getLanguage"]),
    init() {
      if (this.releaseID === -1) {
        this.releaseFormID = window.sessionStorage.getItem("approvalReleaseID")
      } else {
        window.sessionStorage.setItem("approvalReleaseID", this.releaseID)
        this.releaseFormID = this.releaseID
      }
      this.getReleaseInfo()
      this.getSignTable()
    },
    goBack() {
      let prevPageParams = window.sessionStorage.getItem("prevPageParams")
      window.sessionStorage.removeItem("prevPageParams")
      let prevPageObject = null
      if (prevPageParams !== null) {
        prevPageObject = JSON.parse(prevPageParams)
        switch (prevPageObject.compName) {
          case "PageSearchReleaseOrder":
            this.setQueryParamsToStorage()
            break
          case "PageMyApprovalRelease_Mobile":
            this.setMobileQueryParamsToStorage()
            break
        }
        this.$router.push({
          name: prevPageObject.routeName,
          params: prevPageObject.key,
        })
      }
    },
    displayPartName(lang, chName, enName) {
      return utils.displayPartName(utils.displayCHName(lang), chName, enName)
    },
    setQueryParamsToStorage() {
      let tempQueryParams = window.sessionStorage.getItem("tempQueryParams")
      window.sessionStorage.removeItem("tempQueryParams")
      window.sessionStorage.setItem("queryParams", tempQueryParams)
    },
    setMobileQueryParamsToStorage() {
      let tempQueryParams = window.sessionStorage.getItem("tempMobileQueryParams")
      window.sessionStorage.removeItem("tempMobileQueryParams")
      window.sessionStorage.setItem("mobileQueryParams", tempQueryParams)
    },
    applyReviewResult() {
      let vueInstance = this
      let params = {
        releaseID: vueInstance.releaseFormID,
      }
      utils.showLoading(vueInstance)
      api
        .apiApprovalRelease(params)
        .then((response) => {
          utils.closeLoading(vueInstance)
          if (response.data.success) {
            vueInstance.$alert(vueInstance.$t("message.alert.successReview"), vueInstance.$t("message.title.success"), {
              confirmButtonText: vueInstance.$t("pages.button.confirm"),
              callback: () => {
                vueInstance.goBack()
              },
            })
          } else {
            vueInstance.$alert(
              vueInstance.$t("message.alert.backend." + response.data.messageCode),
              vueInstance.$t("message.title.Warning"),
              {
                confirmButtonText: vueInstance.$t("pages.button.confirm"),
                callback: () => {
                  vueInstance.goBack()
                },
              }
            )
          }
        })
        .catch(function (e) {
          utils.closeLoading(vueInstance)
          console.log(e)
        })
    },
    getReleaseInfo() {
      let vueInstance = this
      let params = { params: { releaseId: vueInstance.releaseFormID } }
      api
        .apiGetReleaseInfo(params)
        .then((response) => {
          if (response.data) {
            let data = response.data.result
            vueInstance.reserveData = data.reserveData
            vueInstance.releaseData = data.releseData
            vueInstance.releaseSOData = data.soList
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getSignTable() {
      let vueInstance = this
      let params = { releaseId: vueInstance.releaseFormID }
      api
        .apiGetSignTable(params)
        .then((response) => {
          if (response.data.success) {
            vueInstance.approvalProgressData = response.data.result
            vueInstance.approvalProgressData.forEach((item) => {
              let hasApproval = item.signDatetime === null
              item.state = hasApproval
                ? vueInstance.$t("pages.wording.waitForApproval")
                : vueInstance.$t("pages.wording.approve")
              item.member = item.signUserName
              item.role = vueInstance.$t("role." + item.signRole)
              item.datetime = vueInstance.parseDateTime(item.signDatetime)
              item.isActive = hasApproval
              if (item.signUserID === null) {
                if (vueInstance.getUserRoles().includes(item.signRole)) {
                  vueInstance.roleNotYetSign = true
                  return
                }
              }
            })
          }
        })
        .catch(function (e) {
          console.log(e)
        })
    },
    parseDateTime(dateTime) {
      return utils.parseISOStringToDateTime(dateTime)
    },
  },
  computed: {
    totalGrossWeight() {
      return parseFloat(
        (this.releaseSOData == null
          ? 0
          : this.releaseSOData.reduce((acc, so) => {
              return acc + parseFloat(so.grossWeight.toFixed(this.$global.defaultPointNumForRelease))
            }, 0)
        ).toFixed(this.$global.defaultPointNumForRelease)
      )
    },
    totalNetWeight() {
      return parseFloat(
        (this.releaseSOData == null
          ? 0
          : this.releaseSOData.reduce((acc, so) => {
              return acc + parseFloat(so.netWeight.toFixed(this.$global.defaultPointNumForRelease))
            }, 0)
        ).toFixed(this.$global.defaultPointNumForRelease)
      )
    },
    weightUnit() {
      return this.releaseSOData !== null && this.releaseSOData.length > 0 ? this.releaseSOData[0].unit : ""
    },
  },
}
</script>

<style scoped>
.PageMyReleaseOrderInfoAuthMobile {
  margin: 0 -16px;
  padding-bottom: 24px;
}

.section-top {
  background: var(--white);
  padding: 40px 16px 16px 16px;
}
</style>
